'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProxy = exports.getBaseUrl = exports.getConfig = exports.setConfig = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _httpsProxyAgent = require('https-proxy-agent');

var _httpsProxyAgent2 = _interopRequireDefault(_httpsProxyAgent);

var _lodash = require('lodash.memoize');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {};

/**
 * Sets the config by extending the existing config with the passed one. Allows lazy config definition.
 * @param {Object} options A key value pair of providerName/baseUrl to extend the current configuration.
 * @returns {void}
 */
var setConfig = exports.setConfig = function setConfig(options) {
    var localConfig = (0, _keys2.default)(options).reduce(function (bag, provider) {
        var providerConfig = options[provider];

        if (typeof providerConfig === 'string') {
            providerConfig = {
                baseUrl: providerConfig
            };
        }

        return (0, _extends4.default)({}, bag, (0, _defineProperty3.default)({}, provider, providerConfig));
    }, {});

    config = (0, _extends4.default)({}, config, localConfig);
};

/**
 * Gets the config from a provider
 * @param {string} provider The provider to get the baseUrl for
 * @returns {string} The baseUrl for the passed provider
 * @throws {Error} An PROVIDER_NOT_INITIALISED error is thrown if no config is found
 */
var getConfig = exports.getConfig = function getConfig(provider) {
    var localConfig = config[provider];
    if (!localConfig) {
        throw Error('PROVIDER_NOT_INITIALISED', provider);
    }

    return localConfig;
};

/**
 * Gets the config from a provider
 * @param {string} provider The provider to get the baseUrl for
 * @returns {string} The baseUrl for the passed provider
 * @throws {Error} An PROVIDER_NOT_INITIALISED error is thrown if no config is found
 */
var getBaseUrl = exports.getBaseUrl = (0, _lodash2.default)(function (provider) {
    return getConfig(provider).baseUrl;
});

/**
 * Gets the proxy for the requested provider if enabled. This function is memoized.
 * @param {String} provider The provider to get the proxy for
 * @returns {agent|undefined} An instance of HttpAgent or undefined if proxy is not
 * set or enabled
 */
var getProxy = exports.getProxy = (0, _lodash2.default)(function (provider) {
    var _getConfig = getConfig(provider),
        proxy = _getConfig.proxy;

    if (proxy) {
        return new _httpsProxyAgent2.default(proxy);
    }

    return undefined;
});
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/config/config.js
// module id = 443
// module chunks = 0